import { render, staticRenderFns } from "./KonnectForm.vue?vue&type=template&id=61dcb462&scoped=true&"
import script from "./KonnectForm.vue?vue&type=script&lang=js&"
export * from "./KonnectForm.vue?vue&type=script&lang=js&"
import style0 from "./KonnectForm.vue?vue&type=style&index=0&id=61dcb462&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61dcb462",
  null
  
)

export default component.exports